import React, { useContext, useState } from 'react';
import { Container, Card, FormActions, FormStack } from './index.styled';
import { Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { api, login } from '../../services';
import { ADD_LOGIN_USER, ADD_TOKEN } from '../../store';
import { AppContext } from '../../shared/providers/AppProvider';
import { useNavigate } from 'react-router-dom';
import { Button, TextField } from '../../components';

const Login: React.FC = () => {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    defaultValues: {
      email: '',
      password: ''
    }
  });
  const { appUsecase } = useContext(AppContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isModalErrorEmail, setModalErrorEmail] = useState(false);

  const onSubmit = (dados: any) => {
    api
      .post('/authorize', dados)
      .then(resposta => {
        dispatch({ type: ADD_LOGIN_USER, user: resposta.data.user });
        dispatch({ type: ADD_TOKEN, token: resposta.data.token });

        appUsecase.setToken(resposta?.data?.token);
        login(resposta?.data?.token);
        navigate('/dashboard');
      })
      .catch(_ => {
        setModalErrorEmail(true);
      });
  };

  return (
    <>
      <Container>
        <Card>
          <form onSubmit={handleSubmit(onSubmit)}>
            <FormStack>
              <TextField
                label="E-mail"
                type="email"
                placeholder="Digite o email do moderador"
                {...register('email', { required: true })}
                data-cy="email"
                error={errors.email ? 'E-mail necessário para o login' : undefined}
              />
              <TextField
                label="Senha"
                type="password"
                placeholder="Digite a senha do moderador"
                {...register('password', { required: true })}
                data-cy="password"
                error={errors.password ? 'Senha necessária para o login' : undefined}
              />
            </FormStack>
            <FormActions>
              <Button
                type="submit"
                size="lg"
                variant="secondary"
                data-cy="submit"
                style={{ minWidth: 240 }}
              >
                Entrar
              </Button>
            </FormActions>
          </form>

          <Modal
            show={isModalErrorEmail}
            onHide={() => {
              setModalErrorEmail(false);
            }}
            dialogClassName="modal-90w"
            aria-labelledby="example-custom-modal-styling-title"
          >
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
              <h1>E-mail/Senha invalidos!!!</h1>
              <p>E-mail/Senha invalidos, tente novamente!!!</p>
            </Modal.Body>
          </Modal>
        </Card>
      </Container>
    </>
  );
};

export default Login;
